class Lifecycles {
    constructor(options) {
        this.iframe = document.createElement('iframe');
        this.routerEvents = (type) => {
            const orig = history[type];
            return function (...args) {
                /* eslint-disable no-invalid-this */
                // @ts-ignore
                const routerValue = orig.apply(this, args);
                const event = new Event(type);
                // @ts-ignore
                event.arguments = args;
                window.dispatchEvent(event);
                return routerValue;
            };
        };
        this.node = options.appOutlet();
        Object.defineProperty(history, 'pushState', {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.routerEvents('pushState'),
        });
        Object.defineProperty(history, 'replaceState', {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.routerEvents('replaceState'),
        });
    }
    bootstrap(options) {
        return Promise
            .resolve()
            .then(() => {
            this.setIframeSrc(options);
            this.iframe.setAttribute('style', 'width: 100%; height: 100%;');
            this.iframe.setAttribute('frameborder', '0');
            window.addEventListener('pushState', () => {
                this.setIframeSrc(options);
            });
        });
    }
    mount(_options) {
        return Promise
            .resolve()
            .then(() => {
            const element = this.node;
            element.appendChild(this.iframe);
        });
    }
    unmount(_options) {
        return Promise
            .resolve()
            .then(() => {
            const element = this.node;
            element.innerHTML = '';
        });
    }
    unload() {
        return Promise
            .resolve();
    }
    setIframeSrc(options) {
        const isRouteSyncEnabled = options.syncRouter;
        const iFrameAttributes = isRouteSyncEnabled ? `${options.appUrl}${window.location.pathname}` : `${options.appUrl}`;
        this.iframe.setAttribute('src', iFrameAttributes);
    }
}
export const singleSpaIframe = (options) => {
    const lifecycles = new Lifecycles(options);
    return {
        bootstrap: () => {
            return lifecycles.bootstrap(options);
        },
        mount: () => {
            return lifecycles.mount(options);
        },
        unmount: () => {
            return lifecycles.unmount(options);
        },
    };
};
